import { useEffect, useRef } from "react";


export default function useReactiveFunctionWithDebouncing({
                                                    functionn = () => true,
                                                    reactiveArgument,
                                                    setReturnedValue = () => {},
                                                    // config/extra
                                                    debouncingDurationMs = 300,
                                                    noDebouncing = false,
                                                    safeToRun = true, // quando muda de falsy para truthy roda uma vez sem debouncing!
                                                    shouldAwaitArgumentPropagation = true, // workaround para o comportamento mencionado acima em componentes com problemas de rerender
                                                    argumentPropagationChances = 1,
                                                  }) {
  
  const debounceTimeoutIdRef = useRef();
  const previousSafeToRunRef = useRef(safeToRun);
  const timesToAwaitArgumentPropagation = useRef(shouldAwaitArgumentPropagation ? argumentPropagationChances : 0);
  
  useEffect(() => {
    if (noDebouncing) {
      if (safeToRun) {
        setReturnedValue(functionn(reactiveArgument));
      }
      return;
    }
    
    if (debounceTimeoutIdRef.current) {
      clearTimeout(debounceTimeoutIdRef.current);
    }
    
    if (safeToRun) {
      if (!previousSafeToRunRef.current) {
        setReturnedValue(functionn(reactiveArgument));
        
      } else {
        debounceTimeoutIdRef.current = setTimeout(() => setReturnedValue(functionn(reactiveArgument)), debouncingDurationMs);
      }
    }
    
    const awaitArgumentPropagation = safeToRun && (reactiveArgument == null || reactiveArgument?.length === 0);
    if (awaitArgumentPropagation && timesToAwaitArgumentPropagation.current > 0) {
      previousSafeToRunRef.current = false;
      timesToAwaitArgumentPropagation.current = 0;
      
    } else {
      previousSafeToRunRef.current = safeToRun;
    }
    
    return () => { if (debounceTimeoutIdRef.current) clearTimeout(debounceTimeoutIdRef.current) }
  }, [noDebouncing, safeToRun, setReturnedValue, functionn, reactiveArgument, debouncingDurationMs]);
}